import React from 'react';
import { DeviceType } from '../../hooks/useMobileOptimizations';
import MobileProductModal from './MobileProductModal';
import IpadProductModal from './IpadProductModal';
import DesktopProductModal from './DesktopProductModal';

interface Produto {
  id: number;
  nome: string;
  descricao: string;
  preco: number;
  imagem_url?: string;
  codigo?: string;
  venda_por_peso?: boolean | number;
}

interface ProductModalProps {
  deviceType: DeviceType;
  isOpen: boolean;
  onClose: () => void;
  produto: Produto | null;
  quantidade: number;
  observacoes: string;
  onQuantidadeChange: (qtd: number) => void;
  onObservacoesChange: (obs: string) => void;
  peso: number | null;
  onPesoChange: (peso: number | null) => void;
  onAdicionar: () => void;
  onCancelar: () => void;
}

/**
 * Componente wrapper que renderiza o modal apropriado baseado no tipo de dispositivo
 * Cada dispositivo tem seu próprio componente isolado para evitar bugs de responsividade
 */
const ProductModal: React.FC<ProductModalProps> = (props) => {
  const { deviceType } = props;

  // Renderizar componente isolado baseado no dispositivo
  switch (deviceType) {
    case 'mobile':
      return <MobileProductModal {...props} />;
    case 'ipad':
      return <IpadProductModal {...props} />;
    case 'desktop':
      return <DesktopProductModal {...props} />;
    default:
      return <DesktopProductModal {...props} />;
  }
};

export default ProductModal;
